import { ResponsiveModalOrBottomSheet } from 'src/components/ResponsiveModalOrBottomSheet/ResponsiveModalOrBottomSheet'
import { useAtom } from 'jotai'
import { CuiButton } from 'front-lib'
import { connectCalendarHelpModalAtom } from 'src/atoms/modals/connectCalendarHelpModal.atom'
import { userOnboardingModalAtom } from 'src/atoms/modals/userOnboardingModal.atom'
import { useExclusiveModal } from 'src/hooks/useExclusiveModalAtom'
import { useState } from 'react'
import { useGetUserCalendar } from 'src/hooks/useGetUserCalendar'

import './ConnectCalendarHelpModal.scss'

export function ConnectCalendarHelpModal() {
  useExclusiveModal(userOnboardingModalAtom)

  const { data } = useGetUserCalendar()

  const [{ isOpen }, setConnectCalendarHelpModal] = useAtom(
    connectCalendarHelpModalAtom
  )
  const [copied, setCopied] = useState(false)

  function handleClose() {
    setConnectCalendarHelpModal({ isOpen: false })
    setCopied(false)
  }

  async function handleCopyLink() {
    await navigator.clipboard.writeText(data?.calendarS3Url ?? '')
    setCopied(true)
    // Reset copied state after 2 seconds
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <ResponsiveModalOrBottomSheet
      isOpen={isOpen}
      onClose={handleClose}
      className="connect-calendar-help-modal-container">
      <div className="connect-calendar-help-modal">
        <div className="connect-calendar-help-modal__content">
          <h2 className="connect-calendar-help-modal__title">
            Trouble connecting?
          </h2>

          <p className="connect-calendar-help-modal__description">
            If you're having trouble connecting your calendar automatically,
            copy the link below and connect it manually by following the
            instructions provided by your preferred calendar app.
          </p>

          <div className="connect-calendar-help-modal__url-container">
            <div className="connect-calendar-help-modal__url">
              {data?.calendarS3Url}
            </div>
            <CuiButton
              className={`connect-calendar-help-modal__copy-button ${
                copied ? 'copied' : ''
              }`}
              onClick={handleCopyLink}
              fill="outline"
              size="small">
              {copied ? 'Copied!' : 'Copy link'}
            </CuiButton>
          </div>
          <div className="connect-calendar-help-modal__close-button-container">
            <CuiButton
              className="connect-calendar-help-modal__close-button"
              onClick={handleClose}
              size="large">
              Close
            </CuiButton>
          </div>
        </div>
      </div>
    </ResponsiveModalOrBottomSheet>
  )
}
